<template>
  <v-card
    flat
    outlined
    tile
  >
    <v-card-title>Record an Offline Payment</v-card-title>
    <v-card-subtitle>Record a purchase of shares of <strong>{{ adminAsset.title }}</strong> via offline payment.</v-card-subtitle>

    <v-card-text class="pb-0">
      <v-row>
        <v-col md="6">
          <v-autocomplete
            v-model="payment.userId"
            :loading="searchLoading"
            :items="adminUserSearchResults"
            item-text="emailAddress"
            item-value="id"
            :search-input.sync="search"
            cache-items
            prepend-icon="mdi-account-search"
            :placeholder="user.emailAddress"
            flat
            label="User Receiving Shares"
          ></v-autocomplete>
        </v-col>

        <v-col md="6">
          <v-text-field
            v-model.number="payment.shares"
            label="Number of shares to purchase"
            :hint="`${adminAsset.sharesForSale} available.`"
            :rules="[
              () => !!payment.shares || 'Number of Shares is Required',
              rules.number
            ]"
            required
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="primary"
        :loading="paymentLoading"
        @click="recordPurchase"
        :disabled="!payment.shares || !payment.userId"
      >
        <v-icon left>
          mdi-account-cash
        </v-icon>
        Record Purchase
      </v-btn>

      <v-btn
        v-if="this.$route.name !== 'flipItemEdit'"
        @click="$emit('dialog-close')"
      >
        <v-icon left>
          mdi-cancel
        </v-icon>
        Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: "OfflinePaymentForm",

    computed: {
      ...mapGetters([
        'adminAsset',
        'adminUserSearchResults',
        'user'
      ])
    },

    data: () => ({
      // Form helpers
      paymentLoading: false,
      searchLoading: false,
      userSelect: null,
      search: null,

      // validation rules
      rules: {
        number: value => {
          return !isNaN(parseFloat(value)) && isFinite(value) || 'Must be numeric.'
        }
      },

      // Payload
      payment: {
        chargeTransferFee: true,
        shares: null,
        userId: null
      }
    }),

    methods: {
      ...mapActions([
        'externalPurchase',
        'userSearch'
      ]),

      // Querying on the users.
      searchUsers (q) {
        this.searchLoading = true

        this.userSearch(q).then(() => {
          this.searchLoading = false
        }).catch(() => {
          this.searchLoading = false
        })
      },

      // Record Purchase
      recordPurchase () {
        this.paymentLoading = true

        this.externalPurchase({
          assetId: this.adminAsset.id,
          purchase: this.payment
        }).then(() => {
          this.paymentLoading = false
          this.$emit('dialog-close')
        })
      }
    },

    watch: {
      adminConsignor: 'updateCheck',
      search (val) {
        val && val !== this.userSelect && this.searchUsers(val)
      }
    }
  }
</script>
